<template>
  <div class="test">
    <modal
      name="my-first-modal"
      width="100%"
      height="80%"
      :shiftX="0"
      :shiftY="0.25"
    >
      <iframe
        src="https://jidobutton.com/m/embed/map/MAPjSbZOdklMP"
        id="myframe"
        width="100%"
      ></iframe
    ></modal>

    <div class="content-header-container">
      <div class="header-title-container">
        <p class="content-title s-core-dream-black">{{ title }}</p>
      </div>
    </div>
    <img
      src="https://firebasestorage.googleapis.com/v0/b/jido-button.appspot.com/o/2.jpeg?alt=media&token=fb2a5201-715d-4ad9-b076-78bed79657f3"
      @click="show()"
    />
    <!-- <iframe
      src="https://jidobutton.com/m/embed/map/MAPjSbZOdklMP"
      id="myframe"
      width="100%"
    ></iframe> -->
  </div>
</template>

<style scoped>
img {
  cursor: pointer;
}
iframe {
  height: 100%;
}
</style>

<script>
import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";
import firebase from "firebase";

export default {
  name: "amen",
  components: {},
  data() {
    return {};
  },
  methods: {
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
  },
  props: ["title"],
};
</script>

<style scoped>
.test {
  margin-top: 30px;
  margin-bottom: 22px;
}

.content-header-container {
  display: flex;
  justify-content: space-between;
  height: 35px;
}

.header-title-container {
  display: flex;
}

.desc-container {
  display: flex;
  flex-direction: column;
}

.content-title {
  font-size: 17px;
}

.content-subtitle {
  color: #f9730c;
  font-size: 17px;
}

p.indent {
  padding-left: 0.4em;
}

.content-title-more {
  color: grey;
}

.horizontal-scroll {
  display: flex;
  width: 100%;
  height: 192px;
}

.outer {
  display: flex;
  flex: 1;
  width: auto;
  height: 100%;
  flex-flow: row nowrap;
}

.content-img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

img {
  width: 100%;
  height: 212px;
  border-radius: 5px;
}
</style>
